var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96.611,
    height: 137.989,
    viewBox: "0 0 96.611 137.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tap",
    transform: "translate(-77.766 -1.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25849",
    "data-name": "Group 25849",
    transform: "translate(77.766 1.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25848",
    "data-name": "Group 25848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25231",
    "data-name": "Path 25231",
    d: "M216.894,12.5a2.3,2.3,0,0,0,2.3-2.3V3.3a2.3,2.3,0,0,0-4.6,0v6.9A2.3,2.3,0,0,0,216.894,12.5Z",
    transform: "translate(-177.717 -1.001)",
    fill: "#5f1f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25232",
    "data-name": "Path 25232",
    d: "M123.639,90.933h6.853a2.3,2.3,0,1,0,0-4.6h-6.853a2.3,2.3,0,1,0,0,4.6Z",
    transform: "translate(-109.596 -63.336)",
    fill: "#5f1f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25233",
    "data-name": "Path 25233",
    d: "M273.936,88.634a2.3,2.3,0,0,0,2.3,2.3h6.853a2.3,2.3,0,0,0,0-4.6h-6.853A2.3,2.3,0,0,0,273.936,88.634Z",
    transform: "translate(-221.066 -63.336)",
    fill: "#5f1f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25234",
    "data-name": "Path 25234",
    d: "M259.28,35.8a2.3,2.3,0,0,0,1.63-.678l4.57-4.6a2.3,2.3,0,0,0-3.264-3.243l-4.567,4.6A2.3,2.3,0,0,0,259.28,35.8Z",
    transform: "translate(-208.68 -19.704)",
    fill: "#5f1f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25235",
    "data-name": "Path 25235",
    d: "M152.011,35.116a2.3,2.3,0,0,0,3.264-3.241l-4.57-4.6a2.3,2.3,0,0,0-3.264,3.24Z",
    transform: "translate(-128.175 -19.697)",
    fill: "#5f1f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25236",
    "data-name": "Path 25236",
    d: "M164.028,106.73a10.286,10.286,0,0,0-5.749,1.748v-.6a10.345,10.345,0,0,0-16.1-8.6v-.6A10.345,10.345,0,0,0,126.1,90.069V71.315a10.3,10.3,0,1,0-20.6,0l0,45.454c-4.889-7.081-14.551-10.6-21.936-7.716a14.037,14.037,0,0,0-2.783,1.527,6.018,6.018,0,0,0-2.964,5.648c-.207,1.2.078,1.545,2.813,4.813,3.521,4.213,10.848,12.978,15.508,21.648.147.234,2.357,3.71,5.473,7.927a2.233,2.233,0,0,1,.938.639c.948,1.141,6.21,4.77,9.353,6.936,2.429,1.674,4.345,3,5.234,3.737a2.3,2.3,0,1,1-2.944,3.535c-.731-.609-2.757-2.005-4.9-3.484-.55-.379-1.076-.745-1.594-1.1l-.018,3.376c0,10.816,8.5,18.371,20.685,18.371H148.93c9.537,0,17.159-5.591,18.962-13.914.193-.89.4-1.624.6-2.247-3.238,1.159-6.237,1.994-7.311,2.284a2.349,2.349,0,0,1-.6.078,2.3,2.3,0,0,1-.6-4.522,77.455,77.455,0,0,0,11.971-4.236,30.61,30.61,0,0,0,2.426-12.4V117.079A10.362,10.362,0,0,0,164.028,106.73Z",
    transform: "translate(-77.766 -44.635)",
    fill: "#5f1f64"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTap);
export default __webpack_public_path__ + "static/media/tap.850dccb9c31d84b429e226d94a1f6a5b.svg";
export { ForwardRef as ReactComponent };